// src/context/unitPartition/context.ts
import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IUnitPartition, IUnitPartitionDetails } from "../../models/unit-partition/response";
import { IUnitPartitionQuery } from "../../models/unit-partition/query";
import { ICreateUnitPartition, IUpdateUnitPartition } from "../../models/unit-partition/request";

export type UnitPartitionLoading = "list" | "details" | "create" | "update" | "delete";

export interface IInternalState {
  loading: UnitPartitionLoading[];
  list?: IBaseListingResponse<IUnitPartition>;
  query: IUnitPartitionQuery;
  details?: IUnitPartitionDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IUnitPartitionDetails) => void;
    createUnitPartition: (request: ICreateUnitPartition) => void;
    updateUnitPartition: (id: number, request: IUpdateUnitPartition) => void;
    deleteUnitPartition: (id: number) => void;
    exportExcel: (data: any) => any;
    setSearch: (search?: string) => void;
    setQuery: (query: IUnitPartitionQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,
    createUnitPartition: DEFAULT_FUNCTION,
    updateUnitPartition: DEFAULT_FUNCTION,
    deleteUnitPartition: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const UnitPartitionContext = createContext(externalState);
export default UnitPartitionContext;
